<template>
  <v-row
    class="mb-1"
    dense
  >
    <v-col
      aria-hidden="true"
      cols="7"
    >
      <div
        v-if="title"
        class="c-black fs-16 fw-600"
      >
        {{ $bct(title) }}
      </div>
      <div
        v-if="subtitle"
        class="c-light-black fs-16 fw-500"
      >
        {{ $bct(subtitle) }}
      </div>
    </v-col>
    <v-col
      class="justify-end d-flex align-center age-group"
      cols="5"
    >
      <v-btn
        @click="decrease"
        ref="minusBtnRef"
        :aria-label="decreaseLabel"
        :disabled="count <= 0"
        class="focus-visible h-28 w-28 me-0"
        variant="text"
        icon
      >
        <v-icon
          class="c-primary fs-24"
          icon="remove_circle"
        />
      </v-btn>
      <v-avatar
        :aria-label="countLabel"
        :class="countClass"
        aria-live="polite"
        class="c-white"
        data-testid="count"
        size="28"
        tabindex="-1"
      >
        {{ count }}
      </v-avatar>
      <v-btn
        @click="increase"
        @keyup.delete="decrease"
        @keyup.down="$emit('down')"
        @keyup.up="$emit('up')"
        ref="plusBtnRef"
        :aria-label="increaseLabel"
        class="focus-visible ms-0"
        data-cy="increase_child_selection"
        variant="text"
        icon
      >
        <v-icon
          class="c-primary h-28 w-28 fs-24"
          icon="add_circle"
        />
      </v-btn>
    </v-col>
  </v-row>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  dense: {
    type: Boolean,
    default: false,
  },
  subtitle: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['decrease', 'down', 'increase', 'up']);

const minusBtnRef = ref(null);
const plusBtnRef = ref(null);

const countClass = computed(() => {
  return props.count > 0 ? 'bg-primary' : 'bg-light-gray';
});

const decreaseLabel = computed(() => {
  const str = [$bct('decrease'), $bct(props.title), $bct('by'), 1].join(' ');
  return str;
});

const increaseLabel = computed(() => {
  let str = [$bct('increase'), $bct(props.title), $bct('by'), 1].join(' ');
  str += $bct(', Press Delete or Backspace to decrease by 1');
  return str;
});

const countLabel = computed(() => {
  return [$bct(props.count.toString()), $bct(props.title)].join(' ');
});

const decrease = () => {
  if (props.count <= 0) return;
  emit('decrease');
};

const increase = () => {
  if (props.count >= 1000) return;
  emit('increase');
};

const focus = () => {
  plusBtnRef.value.$el.focus();
};

defineExpose({
  focus,
});
</script>
